export const USER_MODULE_NAME = 'user'
export const USER_SET_ID = 'USER_SET_ID'
export const USER_SET_ROLE = 'USER_SET_ROLE'
export const USER_SET_FLOW = 'USER_SET_FLOW'
export const USER_SET_FLOW_HAS_IMAGES = 'USER_SET_FLOW_HAS_IMAGES'
export const USER_SET_FLOW_STATE = 'USER_SET_FLOW_STATE'
export const USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT = 'USER_SET_MANAGE_DAMAGE_APPOINTMENT_FLOW_RESULT'
export const USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT = 'USER_SET_MANAGE_DAMAGE_BILLMA_FLOW_RESULT'
